import {Domain} from '../../white-label/permission'

export const getCurrentDomainName = (): string => {
  const {hostname} = window.location
  return hostname as Domain
}
